import {SchemaTag} from 'folder-items/FileConstants';
import {Note} from 'notebook/util/NoteUtilConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import runModal from 'ui-library/runModal';
import {WorklistType} from 'worklists/WorklistConstants';

import AddSamplesFromWorklistModal from '../AddSamplesFromWorklistModal';
import {SampleFilters} from '../SampleFilter';
import makeSampleDetailsFromSampleIds from '../util/makeSampleDetailsFromSampleIds';
import {sampleFilterToWorklistType} from '../util/SampleTypeWorklistTypeConversions';
import {addSamplesToTag} from './addSamplesToTagUtils';

export default async function addSamplesFromWorklistToTag(
  note: Note,
  sourceTag: SchemaTag,
  fieldType: FieldType,
  sampleFilters: SampleFilters
): Promise<SchemaTag | null> {
  let newTag = null;

  const worklistTypes: Array<WorklistType> = sampleFilters
    .map((filter) => sampleFilterToWorklistType(filter))
    .filter((worklistType): worklistType is WorklistType => worklistType != null);

  const destinationSampleType = sampleFilters.length === 1 ? sampleFilters[0] : null;

  const addSamplesCommand = await runModal(AddSamplesFromWorklistModal, {
    worklistTypes,
    destinationSampleType,
  });

  if (addSamplesCommand) {
    const sampleDetails = makeSampleDetailsFromSampleIds(addSamplesCommand.worklist.itemIds);
    newTag = addSamplesToTag(sampleDetails, sourceTag, fieldType);
  }

  return newTag;
}
